import { useMe } from "@/context/Me";
import { Tape } from "@/components/bits";

const OPTS = [
  { c: "BR", flag: "🇧🇷", name: "Brasil", sub: "Preços em R$ · CPF · profissionais no Brasil" },
  { c: "PT", flag: "🇵🇹", name: "Portugal", sub: "Preços em € · NIF · profissionais em Portugal" },
];

export default function CountryGate() {
  const { chooseCountry } = useMe();
  return (
    <div className="flex min-h-screen flex-col" data-testid="country-gate">
      <Tape className="h-2" />
      <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center px-5 py-12">
        <div className="mb-10 flex items-center gap-3 fade-up">
          <img src="/icon-192.png" alt="" className="h-12 w-12 rounded-xl" />
          <span className="font-display text-4xl font-black uppercase tracking-tight">Zel<span className="text-[#FFC700]">obra</span></span>
        </div>
        <div className="eyebrow mb-2 fade-up">Bem-vindo</div>
        <h1 className="text-4xl font-black uppercase leading-[0.95] sm:text-5xl lg:text-6xl fade-up">Onde fica a sua obra?</h1>
        <p className="mt-4 max-w-lg text-slate-400 fade-up">Escolha o país para ver preços, profissionais e lojas da sua região.</p>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {OPTS.map((o, i) => (
            <button key={o.c} type="button" data-testid={`country-gate-${o.c}`} onClick={() => chooseCountry(o.c)}
              className="panel panel-hover group p-6 text-left fade-up transition-colors hover:border-[#FFC700]/70" style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
              <div className="text-5xl">{o.flag}</div>
              <div className="mt-4 font-display text-3xl font-black uppercase group-hover:text-[#FFC700]">{o.name}</div>
              <div className="mt-1 text-sm text-slate-400">{o.sub}</div>
            </button>
          ))}
        </div>
        <p className="mt-8 text-xs text-slate-500">Pode trocar depois no topo da página.</p>
      </div>
    </div>
  );
}
